import { ELECTRICITY_METER_ID_LENGTH } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

/**
 * Single source of truth for the "can this meter be saved right now?" rule.
 *
 * Used by:
 *   - useElectricityMeterSave / useGasMeterSave (drive the per-module save
 *     button's `disabled` state — historically the only consumer).
 *   - The global client-tab save orchestrator (CLIENT_TAB_SAVE_ALL) — needs
 *     to skip dirty meters that don't yet pass the gate, with the same rule
 *     as the per-module button, otherwise the two would drift over time.
 *
 * The rule is country-specific:
 *   - DE: pdlNo present AND `isValidPdl === true` (length check skipped).
 *   - FR: eligibility payload received AND meter id matches one of the
 *         expected lengths.
 *   - Others: meter id matches one of the expected lengths (no eligibility).
 */
export const isElectricityMeterDataReady = ({ electricityMeter = {}, country } = {}) => {
  const { pdlEligibilityData = {}, pdlNo = '', isValidPdl = false } = electricityMeter
  if (country === 'de') {
    return !!pdlNo && isValidPdl
  }
  const hasEligibility = Object.keys(pdlEligibilityData || {}).length > 0
  const hasCorrectLength = ELECTRICITY_METER_ID_LENGTH[country]?.includes(pdlNo.length)
  return (hasEligibility || country !== 'fr') && hasCorrectLength
}

/**
 * Same idea for the gas meter (PCE):
 *   - FR: eligibility payload received AND pceNo present AND isValidPce.
 *   - Others: pceNo present AND isValidPce (no eligibility requirement).
 */
export const isGasMeterDataReady = ({ gasMeter = {}, country } = {}) => {
  const { pceEligibilityData = {}, pceNo = '', isValidPce = false } = gasMeter
  return (Object.keys(pceEligibilityData || {}).length > 0 || country !== 'fr') && !!pceNo && isValidPce
}
